import React from 'react';
import ChevronLeftIcon from '../../../components/icons/ChevronLeftIcon';
import PageButton from './PageButton';
import IPaginationButtonProps from './types';

const ChevronLeft: React.FC<IPaginationButtonProps> = (props) => {
  return (
    <PageButton {...props} className="control">
      <ChevronLeftIcon className="pagination-icon" />
    </PageButton>
  );
};

export default ChevronLeft;
